import pako from 'pako';

export const decompressData = (compressedData) => {
    try {
        // Convert base64 to Uint8Array
        const binaryString = atob(compressedData);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        // Decompress the data
        const decompressedData = pako.inflate(bytes, { to: 'string' });
        
        // Replace NaN with null before parsing
        const validJsonString = decompressedData.replace(/: ?NaN/g, ': null');
        
        try {
            // Attempt to parse JSON
            return JSON.parse(validJsonString);
        } catch (jsonError) {
            console.error('JSON Parse Error:', jsonError);
            console.error('First 200 characters of invalid JSON:', validJsonString.substring(0, 200));
            return null;
        }
    } catch (error) {
        console.error('Decompression Error:', error);
        console.error('Compressed data type:', typeof compressedData);
        console.error('Compressed data length:', compressedData?.length);
        return null;
    }
}; 